import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { CompanySelectorWebComponent } from '../../../companySelector';
import { WEB_COMPONENT_COMPANY_SELECTOR } from '../../../webcomponents.constants';

export class IntegrationSelectCompanyWebView extends BaseWebComponentView {
  public dom: {
    $companySelector: CompanySelectorWebComponent;
    $title: HTMLElement;
    $integrationSelectCompanyWrapper: HTMLElement;
  };

  public getDomElements(): void {
    this.dom = {
      $title: this.shadow.querySelector('#select-company-title'),
      $companySelector: this.shadow.querySelector(WEB_COMPONENT_COMPANY_SELECTOR),
      $integrationSelectCompanyWrapper: this.shadow.querySelector('#integrationSelectCompanyWrapper'),
    };
    this.getTranslations();
    this.setTranslatedStrings();
  }

  public getTranslations() {
    this.translations = this.stringsTranslator.getSensorsIntegrationsStrings();
    this.commonStrings = this.stringsTranslator.getCommonStrings();
    return this.translations;
  }

  public setTranslatedStrings(): void {
    this.dom.$title.innerText = this.dependencies.translateFn('Select the company where the sensor should be added');
  }

  public buildView(): void {}
}
